import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import styles from './FullPageDialog.module.css';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullPageDialog({
  open,
  setOpen,
  title,
  children,
  disableEscapeKeyDown = false,
  closeButtonTestId,
}) {
  return (
    <div className={styles.dialog}>
      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        disableEscapeKeyDown={disableEscapeKeyDown}
      >
        <div className={styles.toolbar}>
          <div className={styles.title}>{title}</div>
          <button
            className={styles.closeButton}
            onClick={() => setOpen(false)}
            data-test-id={closeButtonTestId}
          >
            Close
          </button>
        </div>
        <div className={styles.content}>{children}</div>
      </Dialog>
    </div>
  );
}
